import { render, staticRenderFns } from "./DocumentDetails.vue?vue&type=template&id=69f04014&scoped=true"
import script from "./DocumentDetails.vue?vue&type=script&lang=js"
export * from "./DocumentDetails.vue?vue&type=script&lang=js"
import style0 from "./DocumentDetails.vue?vue&type=style&index=0&id=69f04014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f04014",
  null
  
)

export default component.exports